var map = {
	"./bg.png": "d68e",
	"./btn_bg.png": "3c57",
	"./calendar.svg": "1a34",
	"./gear.svg": "5cc9",
	"./home.svg": "86e6",
	"./logo.svg": "9b19",
	"./notes.svg": "7201",
	"./notification.svg": "cd87",
	"./out.svg": "b8c3",
	"./place.svg": "1251",
	"./plane.svg": "07b8",
	"./profile.svg": "b855",
	"./search.svg": "51f2",
	"./sprite.svg": "8a78",
	"./statistic.svg": "0f27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";